import type { Tables } from '$/database.types';

type ExportProfile = Pick<Tables<'users'>, 'role' | 'brand_role'>;

/** USER_STORIES §14 / Story 12 — auditor, admin, CEO brand role. */
export function canExportAudit(profile: ExportProfile | null | undefined): boolean {
  if (!profile) return false;
  if (profile.role === 'admin' || profile.role === 'auditor') return true;
  // Onboarding stores display labels e.g. "CEO", not lowercase slugs.
  return profile.brand_role?.trim().toLowerCase() === 'ceo';
}
